/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/tabindex-no-positive */
import React, { useEffect, useRef, useState } from 'react'

import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import { Box, Button, Grid, makeStyles } from '@material-ui/core'
import colors from '../../../assets/colors'

import { show, syncNationalNfse } from '../LaundryEletronicInvoiceActions'
import { Skeleton } from '@material-ui/lab'
import LaundryConfig from './Forms/LaundryConfig'
import NfseConfig from './Forms/NfseConfig'
import NfsenConfig from './Forms/NfsenConfig'
import Tab from '../../../components/hooks/BaseTabs/Tab'
import Tabs from '../../../components/hooks/BaseTabs/Tabs'
import Icon from '@mdi/react'
import { mdiLoading } from '@mdi/js'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles({
  subTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  company_box: {
    padding: '8px',
    borderRadius: '3px',
    boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.2)',
  },
  details_box: {
    padding: '12px',
    borderRadius: '3px',
    boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  btnSave: {
    borderRadius: '20px',
    color: '#FFF',
    backgroundColor: colors.primary,
    fontSize: '12px',
    textTransform: 'capitalize',
    width: '101px',
    padding: '4px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: '.7',
    },
  },
  uploadLogo: {
    width: '100%',
    height: '100%',
    border: `1px dashed ${colors.primary}`,
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontSize: '14px',
    borderRadius: '10px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: '#FFF',
      opacity: '.6',
    },
  },
  certificateStatus: {
    fontSize: '12px',
    color: colors.graylight,
  },
  cartifacateValidate: {
    backgroundColor: colors.bgSucess,
    borderRadius: '15px',
    color: colors.primary,
    fontSize: '12px',
  },
  segmented: {
    display: 'inline-flex',
    border: `1px solid ${colors.graylight}`,
    borderRadius: '20px',
    overflow: 'hidden',
  },
  segmentedItem: {
    border: 'none',
    borderRadius: '0',
    padding: '6px 20px',
    fontSize: '13px',
    textTransform: 'capitalize',
    color: colors.grayMedium,
    backgroundColor: 'transparent',
    transition: 'all .3s ease-in-out',
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: '.7',
    },
  },
  segmentedItemActive: {
    color: '#FFF',
    backgroundColor: colors.primary,
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: '.85',
    },
  },
  registrationHint: {
    fontSize: '13px',
    color: colors.graylight,
  },
})

const LaundryEletronicInvoice = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [tab, setTab] = useState(0)
  const [loading, setLoading] = useState(false)
  const [haveRegistration, setHaveRegistration] = useState(false)
  const [loadingEletronicInvoiceNational, setLoadingEletronicInvoiceNational] =
    useState(false)
  const [eletronicInvoiceNational, setEletronicInvoiceNational] =
    useState(false)

  const [form, setForm] = useState({
    cnpj: '',
    nome: '',
    validade_certificado: '',
  })

  const verifyIfHaveRegistration = async () => {
    try {
      setLoading(true)
      const resp = await show()

      if (resp?.data) {
        const { data, eletronic_invoice_national } = resp

        setForm({
          ...form,
          ...data,
        })

        setEletronicInvoiceNational(eletronic_invoice_national)
        setHaveRegistration(true)
      }
    } catch (e) {
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleChangeEletronicInvoiceNational = async (active = false) => {
    try {
      setLoadingEletronicInvoiceNational(true)
      const resp = dispatch(syncNationalNfse(active))
      setEletronicInvoiceNational(active)
    } catch (e) {
      console.log(e)
    } finally {
      setLoadingEletronicInvoiceNational(false)
    }
  }

  useEffect(() => {
    verifyIfHaveRegistration()
  }, [])

  return (
    <BaseCreatePage
      page="Lavanderia"
      path="Dados do cadastro de NFSe"
      pageLink="/"
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box className={classes.subTitle}>
            Integração do sistema para geração de NFSe
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Tabs>
            <Tab
              label="Dados da Empresa"
              value={tab}
              setValue={setTab}
              tabIndex={0}
              removeNavigation={false}
            />
            <Tab
              label="Configurações de Emissão"
              value={tab}
              setValue={setTab}
              tabIndex={1}
              removeNavigation={false}
              disabled={!haveRegistration}
            />
          </Tabs>
        </Grid>

        {!loading && !haveRegistration && (
          <Grid item xs={12}>
            <Box className={classes.registrationHint}>
              Cadastre os dados da empresa para liberar as configurações de
              emissão.
            </Box>
          </Grid>
        )}

        <Grid item xs={12} hidden={!loading}>
          <Skeleton
            variant="rect"
            width="100%"
            height={88}
            style={{ borderRadius: '.4em' }}
          />
        </Grid>

        {!loading && tab == 0 && (
          <Grid item xs={12}>
            <LaundryConfig
              haveRegistration={haveRegistration}
              setHaveRegistration={setHaveRegistration}
              reloadVerifyRegistratiron={verifyIfHaveRegistration}
              registrationData={form}
            />
          </Grid>
        )}

        {!loading && tab == 1 && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box className={classes.segmented}>
                  <Button
                    className={`${classes.segmentedItem} ${
                      !eletronicInvoiceNational
                        ? classes.segmentedItemActive
                        : ''
                    }`}
                    disabled={loadingEletronicInvoiceNational}
                    onClick={() => handleChangeEletronicInvoiceNational(false)}
                  >
                    Municipal
                  </Button>
                  <Button
                    className={`${classes.segmentedItem} ${
                      eletronicInvoiceNational
                        ? classes.segmentedItemActive
                        : ''
                    }`}
                    disabled={loadingEletronicInvoiceNational}
                    onClick={() => handleChangeEletronicInvoiceNational(true)}
                  >
                    Nacional
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12}>
                {!eletronicInvoiceNational ? (
                  <NfseConfig active />
                ) : (
                  <NfsenConfig active />
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </BaseCreatePage>
  )
}

export default LaundryEletronicInvoice
